import { render, staticRenderFns } from "./AssetsOnWallets.vue?vue&type=template&id=32a79a96&"
import script from "./AssetsOnWallets.vue?vue&type=script&lang=js&"
export * from "./AssetsOnWallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports